<script setup lang="ts">
import { ref } from "vue";
import { DbSelect } from "@db-ui/v-elements-enterprise/dist/components";
const choice = ref("");
const props = defineProps({
  value: {
    default: "",
  },
  disabled: {
    default: false,
  },
  errorMessage: {
    type: String,
    default: undefined,
    required: false,
  },
  name: {
    default: "",
    required: true,
  },
  label: {
    default: "",
    required: true,
  },
  ariainvalid: {
    type: Boolean,
    default: false,
    required: false,
  },
  variant: {
    type: String as () => "outline" | "semitransparent" | "solid" | "white",
    default: "semitransparent",
    required: false,
  },
});
</script>
<template>
  <div :class="`flex flex-col ${props.errorMessage ? 'invalidArea' : ''}`">
    <db-select
      :label="label"
      :name="name"
      :disabled="disabled"
      :value="value"
      variant="semitransparent"
      @select="$emit('update:modelValue', $event.target.value)"
      ref="choice"
      :ariainvalid="false"
      ><slot></slot
    ></db-select>
    <span v-if="errorMessage"
      ><p class="showError" v-html="errorMessage"></p
    ></span>
  </div>
</template>
<style scoped>
.default-input-class {
  margin-top: 0px;
}

.invalidArea {
  :deep(.elm-select.sc-db-select) {
    --formElement---borderBottomColor: #ec0016;
  }
}

.showError {
  color: #ec0016;
}
</style>
